<template>
  <div class="detail">
    <van-nav-bar title="消息" left-text="返回" left-arrow @click-left="$router.go('-1')" />
    <div class="de-page">
      <div class="de-top">
        <div class="det-title">{{ info.title }}</div>
        <div>班级：{{ className }}</div>
        <div>时间：{{ info.createdAt }} 发布</div>
      </div>

      <div class="de-cont">
        <div class="dec-top">
          <span>详情</span>
          <div @click="toggleClass">
            {{ isShow ? '收起' : '展开' }}
            <div class="triangle" :class="{ top: isShow }"></div>
          </div>
        </div>
        <div class="dec-conts" v-if="isShow">
          {{ info.content }}
          <div class="imgs-box">
            <img
              v-for="(item, index) in attachment"
              :src="item"
              :key="index"
              class="imgs"
              @click="openImg(attachment, index)"
            />
          </div>
        </div>
      </div>

      <div class="page-btn">
        <van-icon name="passed" size="20" /> &nbsp;&nbsp;您已确认收到此通知
      </div>
    </div>
  </div>
</template>
<script>
import { Icon, ImagePreview } from 'vant'

export default {
  data() {
    return {
      isShow: true,
      publishId: '',
      studentId: '',
      info: {},
      attachment: [],
      className: '',
    }
  },
  created() {
    this.publishId = this.$route.query.publishId
    this.studentId = this.$route.query.studentId
    this.getDetail()
    this.setRead()
  },
  components: {
    'van-icon': Icon,
  },

  methods: {
    getDetail() {
      let api = this.$api.notice.detail
      this.$http
        .get(api, {
          studentId: this.studentId,
          publishId: this.publishId,
        })
        .then((data) => {
          if (data.code == 0) {
            const res = data.data
            this.info = res
            if (res.attachment && res.attachment !== '') {
              this.attachment = res.attachment.split(',')
            }
            if (res.classInfoDTO && res.classInfoDTO.length > 0) {
              let names = res.classInfoDTO.map((item) => {
                return item.className
              })
              this.className = names.join(',')
            }
          }
        })
    },

    setRead() {
      let api = this.$api.notice.read
      this.$http
        .get(api, {
          studentId: this.studentId,
          publishId: this.publishId,
        })
        .then((data) => {
          if (data.code == 0) {
            const res = data.data
          }
        })
    },

    openImg(data, index) {
      ImagePreview({
        images: data,
        startPosition: index,
        closeable: true,
      })
    },

    toggleClass() {
      this.isShow = !this.isShow
    },
  },
}
</script>

<style lang="scss" scoped>
.imgs-box {
  display: flex;
  flex-wrap: wrap;
  margin-top: 10px;
  .imgs {
    height: 90px;
    width: 90px;
  }
}
.detail {
  height: 100%;
}
.de-page {
  padding: 0 20px;
  position: relative;
  height: 100%;
}
.de-top {
  padding: 15px 0;
  font-family: PingFangSC, PingFang SC;
  font-weight: 500;
  font-size: 12px;
  color: #2c2d32;
  line-height: 17px;
  .det-title {
    font-weight: 600;
    font-size: 20px;
    margin-bottom: 15px;
  }
}

.de-cont {
  background: #fff;
  padding: 0 9px;
  border-radius: 20px;
  .dec-top {
    padding: 17px 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-weight: 600;
    font-size: 16px;
    color: #2c2d32;
  }
  .dec-conts {
    padding-bottom: 17px;
    font-weight: 400;
    font-size: 12px;
    color: #3b3b3b;
    line-height: 20px;
    white-space: pre-wrap;
  }
}
.page-btn {
  position: absolute;
  bottom: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: calc(100% - 40px);
  font-weight: 600;
  font-size: 13px;
  color: #717377;
}

.top {
  -webkit-transform: rotate(180deg);
  transform: rotate(180deg);
}

.triangle {
  width: 0;
  display: inline-block;
  height: 0;
  //   margin-top: 14px;
  margin-left: 10px;
  border-left: 8px solid transparent;
  border-right: 8px solid transparent;
  border-bottom: 8px solid #2c2d32;
}
</style>
